import { useSelector } from 'react-redux';

import { IEmbeddedContactForm, IStandartContactForm, IAttributesContactForm } from 'src/typings/app';
import { requestSelectors } from 'src/store/requests/selectors';

export const useEmbeddedContactForm = () => {
  const contactForm: IEmbeddedContactForm | null | undefined = useSelector(requestSelectors.app.getEmbeddedContactForm);

  return {
    contactForm,
  };
};

export const useStandardContactForm = () => {
  const standardForm: IStandartContactForm | null | undefined = useSelector(requestSelectors.app.getStandardContactForm);

  return {
    standardForm,
  };
};

export const useAttributesContactForm = () => {
  const attributesForm: IAttributesContactForm | null | undefined = useSelector(requestSelectors.app.getAttributesContactForm);

  return {
    attributesForm,
  };
};
